
































































































































































import ICustomerContacts from '@/store/models/ICustomerContacts';
import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class CustomerContactsSelector extends Vue {
    searchCustomerContacts: string = "";
    isValid: boolean = true;
    dialog: boolean = false;
    headers: any = [
        { text: 'Name',
            align: 'start',
            value: 'name'
        },
        { text: 'Email', value: 'email' },
        { text: 'Prefix', value: 'prefix' },
        { text: 'Phone Number', value: 'phoneNumber' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    sortBy: string = 'name';
    sortDesc: boolean = false;
    editedIndex : number = -1;
    editedItem : ICustomerContacts = {
        id: "",
        name: "",
        email: "",
        prefix: "",
        idListPhonePrefix: "",
        phoneNumber: "",
        idCustomer: ""
    }
    defaultItem : any = {
        id: "",
        name: "",
        email: "",
        prefix: "",
        idListPhonePrefix: "",
        phoneNumber: "",
        idCustomer: ""
    }

    @Prop({ type: Array, required: true })
    CustomerContactsList !: ICustomerContacts[];
    @Prop({ type: Array, required: true })
    ListPhonePrefix !: IListPhonePrefix[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    
    selectedCustomerContact : ICustomerContacts[] = [];
    selectedPhonePrefix: any = null;
    phonePrefixCountry : string[] = [];

    get ListPhonePrefixesSort () {
        return [...this.ListPhonePrefix].sort((a, b) => a.prefix.localeCompare(b.prefix));
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Customer Contact' : 'Edit Customer Contact'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    editCustomerContacts (item: any, dbox = true) {
        if (this.selectedCustomerContact.length > 0) {
            this.editedIndex = this.CustomerContactsList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.selectedPhonePrefix = this.ListPhonePrefix.find(p => p.id === this.editedItem.idListPhonePrefix);
            this.dialog = true;
        }
    }

    saveCustomerContacts (customerContact: ICustomerContacts) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.setCountryPrefix();
            if (this.editedIndex > -1) {
                this.$emit('editCustomerContact', this.editedItem);
                Object.assign(this.CustomerContactsList[this.editedIndex], this.editedItem);
            } else {
                this.$emit('saveCustomerContact', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteCustomerContacts (customerContact: ICustomerContacts) {
        if (this.selectedCustomerContact.length > 0) {
            this.$emit('deleteCustomerContact', customerContact);
            this.close();
        }
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    setCountryPrefix() {
        if (this.selectedPhonePrefix) {
            let phonePrefix: IListPhonePrefix = this.ListPhonePrefix.find(p => p.country === this.selectedPhonePrefix.country)!;
            if (phonePrefix) {
                this.editedItem.idListPhonePrefix = phonePrefix.id;
                this.editedItem.prefix = phonePrefix.prefix;
            }
        }
    }

    select(item : ICustomerContacts) : void {
        let index : number = this.selectedCustomerContact.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedCustomerContact = [item];
        } else {
            let customerContact = this.selectedCustomerContact.find(w => w.id === item.id);
            if (!customerContact) {
                this.selectedCustomerContact = [];
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
